<div class="epidemiology-search-dialog">
  <div *ngIf="labOptions.length > 1" class="epidemiology-dialog-field">
    <label class="epidemiology-label" for="epi-dialog-lab">{{ 'WEB_RESULTS.EPIDEMIOLOGY.LAB_SELECTOR' | translate }}</label>
    <p-dropdown
      inputId="epi-dialog-lab"
      id="epi-dialog-lab"
      [options]="labOptions"
      [(ngModel)]="selectedLab"
      optionLabel="label"
      [filter]="true"
      [placeholder]="'WEB_RESULTS.EPIDEMIOLOGY.LAB_SELECTOR' | translate"
      appendTo="body"
      styleClass="w-full"
    ></p-dropdown>
  </div>

  <section class="epidemiology-criteria" [attr.aria-label]="'WEB_RESULTS.EPIDEMIOLOGY.PANEL_TITLE' | translate">
    <p-message *ngIf="panelMessage" severity="info" [text]="panelMessage"></p-message>

    <div class="epidemiology-date-group">
      <label class="epidemiology-label" for="epi-dialog-date-from">{{ 'WEB_RESULTS.EPIDEMIOLOGY.DATE_FROM' | translate }}</label>
      <p-calendar
        inputId="epi-dialog-date-from"
        [(ngModel)]="dateFrom"
        dateFormat="dd/mm/yy"
        [readonlyInput]="true"
        [firstDayOfWeek]="1"
        [minDate]="minEpidemiologyDate"
        [maxDate]="dateFromMaxDate"
        [showClear]="false"
        [showButtonBar]="true"
        panelStyleClass="epidemiology-datepicker-no-clear"
        appendTo="body"
        (onSelect)="onDateFromChange($event)"
        (ngModelChange)="onDateFromChange($event)"
      ></p-calendar>
    </div>
    <div class="epidemiology-date-group">
      <label class="epidemiology-label" for="epi-dialog-date-to">{{ 'WEB_RESULTS.EPIDEMIOLOGY.DATE_TO' | translate }}</label>
      <p-calendar
        inputId="epi-dialog-date-to"
        [(ngModel)]="dateTo"
        dateFormat="dd/mm/yy"
        [readonlyInput]="true"
        [firstDayOfWeek]="1"
        [minDate]="dateToMinDate"
        [maxDate]="maxDateTo"
        [showClear]="false"
        [showButtonBar]="true"
        panelStyleClass="epidemiology-datepicker-no-clear"
        appendTo="body"
        (onSelect)="onDateToChange($event)"
        (ngModelChange)="onDateToChange($event)"
      ></p-calendar>
    </div>
    <div class="epidemiology-actions epidemiology-dialog-actions">
      <p-button
        [label]="'WEB_RESULTS.EPIDEMIOLOGY.SEARCH_BUTTON' | translate"
        icon="pi pi-external-link"
        (onClick)="openEpidemiologyView()"
        [disabled]="!canOpen || loading"
        [attr.aria-label]="'WEB_RESULTS.EPIDEMIOLOGY.SEARCH_BUTTON' | translate"
      ></p-button>
    </div>
  </section>
</div>
